<template>
  <div class="showMessageFileBox">
    <div class="upload_scroller_container">
      <div class="uploadBox">
        <!-- 视频显示 -->
        <div class="video-container" v-if="file.mimetype.indexOf('video') != -1">
          <!-- <p class="file_name">{{ file.file_name }}</p> -->
          <video :src="file.file_path" controls></video>
        </div>
        <!-- 音频显示 -->
        <div class="voice-container" v-else-if="file.mimetype.indexOf('voice') != -1">
          <!-- <p class="file_name">{{ file.file_name }}</p> -->
          <audio :src="file.file_path" width="90%" height="50" controls />
        </div>
        <!-- Excel显示 -->
        <div class="upload-container flex aic" v-else-if="file.file_path.indexOf('xls') != -1"
          @click="downloadFile(file.file_path)">
          <div class="file-thumbnail-container">
            <img src="./img/X图标.png" />
          </div>
          <div class="base-entity-text-contents">
            <p class="file-text">{{ file.file_name }}</p>
            <p class="file-description">Excel</p>
          </div>
        </div>
        <!-- Word显示 -->
        <div class="upload-container flex aic" v-else-if="file.file_path.indexOf('doc') != -1"
          @click="downloadFile(file.file_path)">
          <div class="file-thumbnail-container">
            <img src="./img/W图标.png" />
          </div>
          <div class="base-entity-text-contents">
            <p class="file-text">{{ file.file_name }}</p>
            <p class="file-description">Word</p>
          </div>
        </div>
        <!-- 文本显示 -->
        <div class="upload-container flex aic" v-else-if="file.mimetype.indexOf('text') != -1"
          @click="downloadFile(file.file_path)">
          <div class="file-thumbnail-container">
            <img src="./img/T图标.png" />
          </div>
          <div class="base-entity-text-contents">
            <p class="file-text">{{ file.file_name }}</p>
            <p class="file-description">Txt</p>
          </div>
        </div>
        <!-- 压缩包显示 -->
        <div class="upload-container flex aic" v-else-if="
          file.suffixName.indexOf('zip') != -1 ||
          file.suffixName.indexOf('rar') != -1
        " @click="downloadFile(file.file_path)">
          <div class="file-thumbnail-container">
            <svg t="1690532817205" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="14547" width="32" height="32">
              <path d="M97.9 376h828.4v269.2H97.9z" fill="#F95F5D" p-id="14548" />
              <path d="M926.3 376V161.5c0-26.6-23.8-50.3-52.1-50.3H149.9c-28.3 0-52.1 23.7-52.1 50.3V376h828.5z m0 0"
                fill="#55C7F7" p-id="14549" />
              <path d="M97.9 645.2v214.5c0 26.6 23.6 50.3 51.7 50.3h725c28.1 0 51.7-23.7 51.7-50.3V645.2H97.9z m0 0"
                fill="#7ECF3B" p-id="14550" />
              <path d="M421.8 111.2h184.9V910H421.8z" fill="#FDAF42" p-id="14551" />
              <path
                d="M606.7 457.4v112.4H413V457.4h193.7m31.1-45.9H381.9c-4.4 0-11.8 4.4-11.8 11.8v179c0 4.4 4.4 11.8 11.8 11.8h255.9c4.4 0 11.8-4.4 11.8-11.8v-179c-2.9-8.8-7.4-11.8-11.8-11.8z m0 0"
                fill="#FFFFFF" p-id="14552" />
            </svg>
          </div>
          <div class="base-entity-text-contents">
            <p class="file-text">{{ file.file_name }}</p>
            <p class="file-description">{{ file.file_name.indexOf("Zip") >= 0 ? "Zip" : "RAR" }}</p>
          </div>
        </div>
        <!-- 图片显示 -->
        <div class="img-container" v-else-if="file.mimetype.indexOf('image') != -1">
          <img :src="file.file_path" @click="PreviewImage(file.file_path)" class="loadImg-container" />
        </div>
        <div class="upload-container flex aic" @click="downloadFile(file.file_path)" v-else>
          <div class="file-thumbnail-container">
            <img src="./img/文件图标.png" />
          </div>
          <div class="base-entity-text-contents">
            <p class="file-text">{{ file.file_name }}</p>
            <p class="file-description"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- 预览图片 -->
    <Preview :showVisible="showVisible" :PreviewFile="PreviewFile" @closePreview="showVisible = false" />
  </div>
</template>
<script>
import Preview from "./Preview.vue";
export default {
  props: {
    file: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    Preview,
  },
  data() {
    return {
      showVisible: false,
      PreviewFile: "",
    };
  },
  watch: {
    file: {
      handler: function (val) {
        let name = val.file_name.split(".");
        val.suffixName = name[name.length - 1];
        if (!val.mimetype) {
          val.mimetype = val.suffixName;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    //下载文件
    downloadFile(file) {
      if (file) {
        window.open(file, "_blank");
      }
    },
    PreviewImage(file) {
      this.showVisible = true;
      this.PreviewFile = file;
    },
  },
};
</script>
<style lang="less">
.showMessageFileBox {
  .upload_scroller_container {
    .upload-container {
      padding: 12px 32px 12px 12px;
      background-color: #fff;
      border: 1px solid rgb(234, 240, 246);
      color: rgb(51, 71, 91);
      border-radius: 12px;
      cursor: pointer;
      position: relative;
      width: 100%;

      .file-thumbnail-container {
        margin-right: 12px;

        svg {
          width: 30px;
          height: 30px;
        }

        img {
          width: 30px;
          height: 30px;
        }
      }
      .base-entity-text-contents {
        width: calc(100% - 42px);
        color: rgb(51, 71, 91);
        .file-text {
          font-weight: 700;
          font-size: 15px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .file-description {
          margin-top: 2px;
          font-size: 13px;
        }
      }
    }

    .video-container {
      position: relative;
      background: #fff;
      border-radius: 12px;
      padding: 5px 10px;

      video {
        width: auto;
        height: auto;
        max-width: 100%;
        border-radius: 12px;
      }
    }

    .voice-container {
      background: #fff;
      border-radius: 12px;
      padding: 5px 10px;

      audio {
        margin-top: 4px;
      }
    }

    .img-container {
      position: relative;
      background: #fff;
      border-radius: 12px;
      padding: 5px 10px;

      >img {
        width: auto;
        height: auto;
        max-width: 100%;
        border-radius: 12px;
      }
    }
  }

  .message_list_item:hover {
    background: #f2f3f5;
  }

  .file_name {
    color: rgba(var(--sk_foreground_max, 29, 28, 29), 0.7);
    font-size: 13px;
    margin-bottom: 5px;
    max-width: 100%;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}
</style>